$(function() {
    console.log('start drop');

    let $AcHead = $('.accordion .head'),
        $drop = $('.drop'),
        $head = $drop.find('.head');

    $drop.find('.toggle').click(function() {

        $(this).parent().toggleClass('open')

        if ($(this).hasClass('open')) $drop.on('shown.bs.dropdown');
    })

    if($('.drop .head')[0]) {

        $head.parent().each(function (){

            if ($(this).hasClass('open'))
                $(this).css({'--h':($(this).find('.body').innerHeight())+'px'});

            else $(this).css({'--h':0});
        })

        $head.click(function() {

            if ($(this).parent().hasClass('open'))
                $(this)
                    .parent()
                    .removeClass('open')
                    .css({'--h': 0});

            else $(this)
                    .parent()
                    .addClass('open')
                    .css({'--h': ($(this).parent().find('.body').innerHeight()) + 'px'});
        })

    }

    if ($('.head[data-target]')[0]) {

        $AcHead.each(function (){

            let acTarget = $(this).data('target');

            if ($(acTarget).hasClass('open'))
                $(acTarget).css({'--h':($(acTarget).find('.body').innerHeight())+'px'});

            else $(acTarget).css({'--h':0});
        })

        $AcHead.click(function() {

            let acTarget = $(this).data('target');

            if ($(acTarget).hasClass('open')) {

                $(acTarget)
                    .css({'--h': 0})
                    .removeClass('open');

                $(this).removeClass('open');

            } else {

                $(acTarget)
                    .addClass('open')
                    .css({'--h': ($(acTarget).find('.body').innerHeight()) + 'px'});

                $(this).addClass('open');
            }
        })
    }

    let btnTarg = $('.btn[data-target]');

    if (btnTarg[0]) {

        btnTarg.click(function() {

            let $modal = $(this).data('target');

            $($modal).addClass('open');

            $($body).addClass('modal-open');

            if($($modal)[0].tagName === 'DIALOG') $($modal)[0].showModal();


        })
    }

    $('.close').on('click', function (){

        closeDialog();

        $(this)
            .parents('.modal')
            .removeClass('open')
            .removeAttr('open');

        $($body).removeClass('modal-open');

        console.log('closeDialog');
    })

    $('.modal').on('click',function(event) {

        if (event.target.matches('.modal')) {

            closeDialog();

            $('.modal').each(function (){

                $(this)
                    .removeClass('open')
                    .removeAttr('open');

                $($body).removeClass('modal-open');
            })
        }
    });


    // Close the dropdown if the user clicks outside of it
    window.onclick = function(event) {

        if (!event.target.matches('.toggle')) {

            $('.drop.wb .in').each(function (){

                $(this).parent().removeClass('open');
            })
        }
    }

    //tabs
    let tabTarg = $('.nav-tabs .item[data-target]');

    if (tabTarg[0]) {

        tabTarg.click(function() {

            if(!$(this).attr('disabled') && !$(this).hasClass('disabled')){

                let $tabCont = $(this).data('target');

                $(this)
                    .parents('.nav-tabs')
                    .find('.item')
                    .removeClass('active');

                $(this).addClass('active');

                $($tabCont)
                    .parents('.tab-cont')
                    .find('.item')
                    .removeClass('open');

                $($tabCont).addClass('open');
            }
        })
    }
});


function closeDialog () {

    let dialog = $('dialog');

    for(let i = 0;dialog.length > i;i++) {

        dialog[i].close();
    }
}